import React from 'react';
import ImportNotifications from '../Onboarding/ImportNotifications';
import { Outlet } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '@src/redux/redux.store';
import Header from '@components/Header/Header';

const DefaultLayout = () => {
  const authenticatedVar = useSelector((state: RootState) => state.auth.isAuthenticated);

  return (
    <Box sx={{ minHeight: '100dvh' }}>
      <CssBaseline />
      <Header isAuthenticated={authenticatedVar} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          px: { xs: 2, sm: 3, lg: 4 },
          py: { xs: 3, sm: 4 },
        }}
      >
        <ImportNotifications />
        <Outlet />
      </Box>
    </Box>
  );
};

export default DefaultLayout;
